import { render, staticRenderFns } from "./AccordionStudentHistory.vue?vue&type=template&id=0b21c726&scoped=true&lang=pug&"
import script from "./AccordionStudentHistory.vue?vue&type=script&lang=ts&"
export * from "./AccordionStudentHistory.vue?vue&type=script&lang=ts&"
import style0 from "./AccordionStudentHistory.vue?vue&type=style&index=0&id=0b21c726&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b21c726",
  null
  
)

export default component.exports